import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { CalendarDays, Clock } from 'lucide-react';
import mapi from './api';
import { MobileShell, MobileHeader, C } from './MobileShell';
import { formatDateWithWeekday, formatTimeRangeUhr } from '@/lib/utils';
import { useMobile } from './MobileContext';
import { isStaffArea } from './areas';

export default function MobileEvents() {
  const { area } = useMobile();
  const [events, setEvents] = useState([]);
  const [openId, setOpenId] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await mapi.get('/app/events');
      const all = r.data || [];
      setEvents(isStaffArea(area) ? all : all.filter((e) => e.audience !== 'personal'));
    } catch (e) { toast.error('Veranstaltungen konnten nicht geladen werden'); }
  }, [area]);
  useEffect(() => { load(); }, [load]);

  const fmtD = (d) => (d ? formatDateWithWeekday(d, { weekday: 'long' }) : '');

  return (
    <MobileShell>
      <MobileHeader title="Veranstaltungen" onRefresh={load} backTo="/m" />
      <div className="flex-1 overflow-y-auto px-4 py-3 pb-10">
        {!events.length && <p className="text-center text-sm mt-10" style={{ color: C.dim }}>Keine Veranstaltungen</p>}
        {events.map((e) => {
          const open = openId === e.id;
          return (
            <div key={e.id} className="rounded-xl mb-3 px-4 py-3.5"
                 style={{ background: C.card, border: `1px solid ${e.cancelled ? C.danger : C.border}`, opacity: e.cancelled ? 0.75 : 1 }}
                 data-testid={`mobile-event-${e.id}`}>
              <div className="flex items-start justify-between gap-2">
                <p className="text-sm font-semibold" style={{ color: C.text }}>{e.title}</p>
                {e.cancelled && (
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded-full text-white shrink-0" style={{ background: C.danger }}
                        data-testid={`mobile-event-cancelled-${e.id}`}>ABGESAGT</span>
                )}
              </div>
              {e.event_date && (
                <p className="text-xs mt-1 flex items-center gap-1.5" style={{ color: C.dim }}>
                  <CalendarDays className="w-3.5 h-3.5" /> {fmtD(e.event_date)}
                  {e.start_time && <><Clock className="w-3.5 h-3.5 ml-1" /> {formatTimeRangeUhr(e.start_time, e.end_time)}</>}
                </p>
              )}
              {e.body && (
                <>
                  <p className={`text-sm mt-2 whitespace-pre-wrap ${open ? '' : 'line-clamp-3'}`} style={{ color: '#c9c9d1' }}>{e.body}</p>
                  {e.body.length > 150 && (
                    <button onClick={() => setOpenId(open ? null : e.id)} className="text-xs mt-2 font-semibold" style={{ color: C.red }}
                            data-testid={`mobile-event-toggle-${e.id}`}>
                      {open ? 'Weniger anzeigen' : 'Weiterlesen'}
                    </button>
                  )}
                </>
              )}
            </div>
          );
        })}
      </div>
    </MobileShell>
  );
}
